module.exports = __webpack_public_path__ + "img/isa3.90c4832d.png";